import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { money, subPrice, subPct, productImage, productSrcSet } from "@/lib/api";
import { TypeBadge, Contains } from "@/components/ProductBadge";
import { ModeToggle, hasSub, MemberLine, BundleSave } from "@/components/ProductExtras";
import { productAlt } from "@/data/seo";

const CardImage = ({ p, eager }) => (
  <img data-testid={`card-image-${p.id}`} src={productImage(p.id, 400)} srcSet={productSrcSet(p.id)} sizes="(max-width: 640px) 50vw, 25vw" alt={productAlt(p)} loading={eager ? "eager" : "lazy"} decoding="async" width="400" height="400" className="aspect-square w-full rounded-2xl object-cover bg-white" />
);

const CardPrice = ({ p }) => {
  const [mode, setMode] = useState("once");
  const sub = hasSub(p);
  const sel = sub && mode === "sub";
  return (
    <>
      <p data-testid={`card-price-${p.id}`} className="mt-3 text-lg font-bold">{money(sel ? subPrice(p) : p.price_usd)}{sel ? " per delivery" : ""}</p>
      <MemberLine p={p} />
      {sub && <p data-testid={`card-sub-save-${p.id}`} className="text-xs text-slate-600">{sel ? `Subscribe & save, ${subPct(p)}% off ${money(p.price_usd)}` : `Save ${subPct(p)}% with Subscribe & save`}</p>}
      <BundleSave p={p} className="mt-1 text-xs" />
      {p.members_only && <p data-testid={`card-members-only-${p.id}`} className="mt-1 text-xs text-slate-600">Captain's Club members only</p>}
      {sub && <ModeToggle p={p} mode={mode} setMode={setMode} />}
    </>
  );
};

export const ProductCard = ({ p, eager = false }) => (
  <div data-testid={`product-card-${p.id}`} className="sticker bg-white p-4 flex flex-col">
    <CardImage p={p} eager={eager} />
    <div className="mt-4 flex flex-wrap gap-2">
      <TypeBadge p={p} />
      {p.ship_countries && <span data-testid={`us-only-tag-${p.id}`} className="rounded-full bg-foam px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-[0.12em] text-navy">US only</span>}
    </div>
    <h3 className="mt-2 text-xl leading-tight">{p.short_name}</h3>
    {p.subtitle && <p data-testid={`card-subtitle-${p.id}`} className="mt-1 text-sm text-slate-600">{p.subtitle}</p>}
    <Contains p={p} />
    <CardPrice p={p} />
    <div className="mt-auto pt-5">
      <Link to={`/shop/${p.id}`} data-testid={`card-view-${p.id}`} className="btn-pop bg-sunny text-navy">{p.coming_soon ? "Coming soon" : "View"} <ArrowRight className="h-4 w-4" /></Link>
    </div>
  </div>
);

export const ShipLine = ({ list, testId }) => {
  const us = list.filter((p) => p.ship_countries).length;
  const text = us === list.length ? "US only."
    : `Ships to the US, Canada, Europe, Australia & NZ.${us ? " Items tagged US only ship to the contiguous US only." : ""}`;
  return <p data-testid={testId} className="mt-3 text-sm font-semibold text-navy">{text}</p>;
};
